import "@/assets/vendor/nucleo/css/nucleo.css"
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import './axios'
import './toast'
import './progress'
import './loader'

import utils from '../utils/utility-methods'

import installComponents from '../components/index'
let installed = false

export default {
  install(Vue) {
    if (installed) return
    installed = true

    Vue.use(BootstrapVue)
    Vue.use(IconsPlugin)
    Vue.use(require('vue-moment'));

    installComponents(Vue)
    Vue.prototype.$utils = utils
  }
};
